import Dialog from "@stimulus-components/dialog"

export default class extends Dialog {
  static targets = ["dialog"]
  static values = {
    open: { type: Boolean, default: false },
    placement: { type: String, default: "right" }
  }

  connect() {
    super.connect()
    this.dialogTarget.addEventListener("close", this.unlockScroll)
  }

  disconnect() {
    this.dialogTarget.removeEventListener("close", this.unlockScroll)
    this.unlockScroll()
    super.disconnect()
  }

  open() {
    super.open()
    document.documentElement.classList.add("overflow-hidden")
  }

  close() {
    super.close()
    this.unlockScroll()
  }

  backdropClose(event) {
    super.backdropClose(event)
  }

  unlockScroll = () => {
    document.documentElement.classList.remove("overflow-hidden")
  }
}
